// ErrorPopup.tsx
import React from 'react';

interface ErrorPopupProps {
  hasPreviousData: boolean;
  onCancel: () => void;
  onBackToHome: () => void;
}

export const ErrorPopup = ({ hasPreviousData, onCancel, onBackToHome }: ErrorPopupProps) => (
  <div style={overlay}>
    <div style={modal}>
      <div style={iconWrapper}>
        <svg
          width={'2.3vw'}
          height={'2.3vw'}
          viewBox="0 0 24 24"
          fill="none"
          stroke="#e53e3e"
          strokeWidth="1.5"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="13" />
          <circle cx="12" cy="16.5" r="0.5" fill="#e53e3e" />
        </svg>
      </div>
      <h2 style={title}>Error Retrieving Data</h2>
      <p style={message}>There was an error retrieving data. Please try again later.</p>
      <div style={actions}>
        {hasPreviousData && (
          <button style={cancelBtn} onClick={onCancel}>
            Cancel
          </button>
        )}
        <button style={homeBtn} onClick={onBackToHome}>
          Back to Home
        </button>
      </div>
    </div>
  </div>
);

const overlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  backgroundColor: 'rgba(0,0,0,0.45)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modal: React.CSSProperties = {
  background: '#fff',
  borderRadius: '0.62vw',
  padding: '2.5vw 2vw',
  maxWidth: '35vw',
  width: '90%',
  textAlign: 'center',
  boxShadow: '0 0.4vw 1.6vw rgba(0,0,0,0.18)',
};

const iconWrapper: React.CSSProperties = {
  margin: '0.5vw auto 1vw',
  width: 'fit-content',
};

const title: React.CSSProperties = {
  fontSize: '1.4vw',
  fontWeight: 700,
  color: '#1a202c',
  margin: '0 0 0.5vw',
};

const message: React.CSSProperties = {
  fontSize: '1.1vw',
  color: '#718096',
  margin: '0 0 1.5vw',
};

const actions: React.CSSProperties = {
  display: 'flex',
  gap: '0.3vw',
  justifyContent: 'center',
};

const cancelBtn: React.CSSProperties = {
  padding: '0.5vw 1.2vw',
  borderRadius: '0.45vw',
  border: '1px solid #e2e8f0',
  background: '#fff',
  color: '#4a5568',
  cursor: 'pointer',
  fontWeight: 500,
  fontSize: '0.88vw',
};

const homeBtn: React.CSSProperties = {
  padding: '0.5vw 1.2vw',
  borderRadius: '0.45vw',
  border: 'none',
  background: '#e53e3e',
  color: '#fff',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '0.88vw',
};
